import * as React from 'react'
import { IconWithText } from '@components/icon-with-text'
import { Icon } from '@components/icon'
import { useModal } from '@modals/use-modal'

export const SubscriptionContractBanner = (): JSX.Element => {
  const [showSubscriptionDescriptionModal] = useModal('SubscriptionContractDescriptionModal', { title: 'Subskrypcja' })

  return (
    <div className="subscription-contract__banner card mt-3 px-4 pe-4 text-darker-gray">
      <strong className="subscription-contract__banner__title">Subskrypcja</strong>
      <p className="text-success fw-bold font-size-xl lh-initial">
        Z subskrypcją zyskujesz dodatkowe atrakcyjne rabaty
      </p>
      <strong className="mb-1">W ramach prezentów otrzymasz:</strong>
      <Benefit>
        <strong className="text-primary">Powiększony rabat </strong>wyjazdowy
      </Benefit>
      <Benefit>
        co rok <strong className="text-primary">darmowy 5-dniowy wyjazd</strong>
      </Benefit>
      <Benefit>
        rabaty <strong className="text-primary">na wyżywienie</strong>
      </Benefit>
      <IconWithText
        onClick={showSubscriptionDescriptionModal}
        text="Zobacz wszystkie benefity"
        iconClassName="uil-plus font-size-lg me-1 lh-0"
        textClassName="fw-semi-bold font-size-md"
        wrapperClassName="mt-3"
      />

      <Icon icon="percent" className="subscription-contract__banner__watermark" />
    </div>
  )
}

const Benefit = ({ children }) => (
  <IconWithText
    iconClassName="text-primary uil-check font-size-xl me-1 lh-1"
    text={<span className="font-size-sm">{children}</span>}
  />
)
